import { ProductLiteModel } from '../product/productLiteModel';
import { PipeInfoModel } from '../product/pipeInfoModel';
import { FittingsModel } from './fittingsModel';
import { FileModel } from '../fileModel';

export class GasInstallationModel {
    public pipeInstall: number;
    public products: Array<ProductLiteModel>;
    public gasInstallWork: boolean;
    public additionalProducts: Array<ProductLiteModel>;
    public pipeInfo: PipeInfoModel;
    public fittings: FittingsModel;
    public activeTab: number;
    public axonometryPdf: FileModel;
}